export default __webpack_public_path__ + "5fa04e451e1aff313f738e141dbe269b.png";